// Building.js (React Router Link-д зориулсан засвар)
import React, { useState, useMemo } from "react";
import "./style.css";
import { FiSearch, FiHome, FiUsers, FiPhone, FiMenu, FiPlus, FiEdit, FiTrash, FiInfo } from "react-icons/fi";
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';

const initialData = [
  { id: 1, owner: "Бат", unit: "1-12", occupants: 3, phone: "99112233", paymentDue: 50000, paymentHistory: [{ month: '2025-11', amount: 50000 }] },
  { id: 2, owner: "Сараа", unit: "2-05", occupants: 2, phone: "88117766", paymentDue: 30000, paymentHistory: [{ month: '2025-11', amount: 30000 }] },
  { id: 3, owner: "Ганболд", unit: "3-09", occupants: 4, phone: "99001122", paymentDue: 0, paymentHistory: [{ month: '2025-11', amount: 0 }] },
  { id: 4, owner: "Мөнх", unit: "4-02", occupants: 1, phone: "96003344", paymentDue: 15000, paymentHistory: [{ month: '2025-11', amount: 15000 }] }
];

Modal.setAppElement('#root');

export default function Building() {
  const [data, setData] = useState(initialData);
  const [search, setSearch] = useState("");
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMode, setModalMode] = useState("add");
  const [currentRecord, setCurrentRecord] = useState(null);
  const [detailModalOpen, setDetailModalOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const navigate = useNavigate();

  const filtered = useMemo(() => {
    return data.filter(
      (item) =>
        item.owner.toLowerCase().includes(search.toLowerCase()) ||
        item.unit.toLowerCase().includes(search.toLowerCase())
    );
  }, [data, search]);

  const openAddModal = () => {
    setModalMode("add");
    setCurrentRecord({ owner: "", unit: "", occupants: 1, phone: "", paymentDue: 0, paymentHistory: [] });
    setModalOpen(true);
  };

  const openEditModal = (record) => {
    setModalMode("edit");
    setCurrentRecord(record);
    setModalOpen(true);
  };

  const saveRecord = () => {
    if(modalMode === "add") {
      const newRecord = { ...currentRecord, id: data.length + 1 };
      setData([newRecord, ...data]);
    } else if(modalMode === "edit") {
      setData(data.map(r => r.id === currentRecord.id ? currentRecord : r));
    }
    setModalOpen(false);
  };

  const deleteRecord = (recordId) => {
    if(window.confirm("Энэ айлыг устгах уу?")) {
      setData(data.filter(r => r.id !== recordId));
    }
  };

  const goToDetailPage = (record) => {
    navigate('/detail', { state: { record } });
  };

  return (
      <div className="main-content">
        <div className="header">
          <button className="menu-btn" onClick={toggleSidebar}><FiMenu /></button>
          <h2 className="dashboard-title">Орон сууцны бүртгэлийн самбар</h2>
          <button className="add-btn" onClick={openAddModal}><FiPlus /> Айл нэмэх</button>
        </div>

        <div className="search-container">
          <FiSearch className="search-icon" />
          <input
            type="text"
            className="search-input"
            placeholder="Хайх (эзэн, байрны дугаар)"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
        </div>

        <div className="table-wrapper">
          <table className="dashboard-table">
            <thead>
              <tr>
                <th>ID</th>
                <th>Эзэмшигч</th>
                <th>Байр</th>
                <th>Оршин суугч</th>
                <th>Утас</th>
                <th>Үлдэгдэл</th>
                <th>Үйлдэл</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan="7" className="no-data">Мэдээлэл олдсонгүй</td>
                </tr>
              ) : (
                filtered.map((row) => (
                  <tr key={row.id}>
                    <td>{row.id}</td>
                    <td>{row.owner}</td>
                    <td>{row.unit}</td>
                    <td>{row.occupants}</td>
                    <td><FiPhone /> {row.phone}</td>
                    <td>
                      <button className="detail-btn" onClick={() => goToDetailPage(row)}>{row.paymentDue.toLocaleString()}₮ <FiInfo /></button>
                    </td>
                    <td className="actions">
                      <button className="edit-btn" onClick={() => openEditModal(row)}><FiEdit /></button>
                      <button className="delete-btn" onClick={() => deleteRecord(row.id)}><FiTrash /></button>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* Add/Edit Modal */}
        <Modal
          isOpen={modalOpen}
          onRequestClose={() => setModalOpen(false)}
          contentLabel="Record Modal"
          className="modal"
          overlayClassName="modal-overlay"
        >
          <h2>{modalMode === "add" ? "Айл нэмэх" : "Айл засах"}</h2>
          <div className="modal-content">
            <label>Эзэмшигч:</label>
            <input type="text" value={currentRecord?.owner || ""} onChange={(e) => setCurrentRecord({...currentRecord, owner: e.target.value})} />
            <label>Байр:</label>
            <input type="text" value={currentRecord?.unit || ""} onChange={(e) => setCurrentRecord({...currentRecord, unit: e.target.value})} />
            <label>Оршин суугч:</label>
            <input type="number" value={currentRecord?.occupants || 1} onChange={(e) => setCurrentRecord({...currentRecord, occupants: parseInt(e.target.value)})} />
            <label>Утас:</label>
            <input type="text" value={currentRecord?.phone || ""} onChange={(e) => setCurrentRecord({...currentRecord, phone: e.target.value})} />
            <label>Үлдэгдэл:</label>
            <input type="number" value={currentRecord?.paymentDue || 0} onChange={(e) => setCurrentRecord({...currentRecord, paymentDue: parseInt(e.target.value)})} />
            <div className="modal-actions">
              <button className="save-btn" onClick={saveRecord}>Хадгалах</button>
              <button className="cancel-btn" onClick={() => setModalOpen(false)}>Цуцлах</button>
            </div>
          </div>
        </Modal>
      </div>
  );
}